
import Menu from './Menu'
import {  Calculate as CalculateIcon } from '@mui/icons-material'
import MenuItem from './MenuItem'


export default function SidebarMenu() {
  window.scrollTo(0, 0)

  return (
    <></>
  )
}
